module.exports = __webpack_public_path__ + "static/media/wubing.89068c84.png";